import { faRobot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { Color } from '@/constants/color';
import { AI_PROFILE_EXAMPLE_QUESTIONS } from '@/pages/PersonAiProfile/constants';
import Badge from '@/ui/components/Badge';
import Tooltip from '@/ui/components/Tooltip';

interface Props {
  personId: string;
}

const AiProfileShortcuts = ({ personId }: Props) => {
  return (
    <>
      {AI_PROFILE_EXAMPLE_QUESTIONS.map((example) => (
        <Tooltip key={example.label} tooltipContent={example.question}>
          <Link
            className="ml-2"
            to={`/people/${personId}/ai-profile?prompt=${encodeURIComponent(example.question)}&autosubmit=true`}>
            <Badge color={Color.INDIGO}>
              <>
                <FontAwesomeIcon icon={faRobot} className="mr-1" />
                {example.label}
              </>
            </Badge>
          </Link>
        </Tooltip>
      ))}
    </>
  );
};

export default AiProfileShortcuts;
